import {pages} from "../../../../shared/constants/pages";
import svgIcons from "../../../../shared/constants/icons/svg-icons";
import routesNames from "../../../../shared/constants/router";
import permissions from "../../../../shared/constants/permissions";


const importSettings = [
  {
    text: pages.import_settings.timesheet_cols_title,
    icon:svgIcons.timesheets,
    routeName: routesNames.administration.colsTimesheet,
    permissions: [permissions.setImportCols],
    applicationOptions: ['invoices']
  },
  {
    text: pages.import_settings.invoice_cols_title,
    icon:svgIcons.invoices,
    routeName: routesNames.administration.colsInvoice,
    permissions: [permissions.setImportCols],
    applicationOptions: ['invoices']
  },
];

export default importSettings;
